export default {
  wrapper: {
    display: 'flex',
    flexDirection: 'row',
    height: '32px',
    width: '100%',
    boxSizing: 'border-box',
    alignItems: 'center'
  },
  check: {
    boxSizing: 'border-box',
    borderRadius: '2px',
    background: 'white',
    width: '20px',
    height: '20px',
    cursor: 'pointer',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    transition: 'background-color 0.3s ease'
  },
  container: {},
  input: {},
  label: {
    display: 'flex',
    alignItems: 'center',
    cursor: 'pointer',
    paddingLeft: '16px',
    fontSize: '14px',
    fontStyle: 'normal',
    fontStretch: 'normal',
    lineHeight: '1.71',
    letterSpacing: 'normal',
    userSelect: 'none'
  }
};